export const setIsAuthenticated = (state, isAuthenticated) => {
  state.isAuthenticated = isAuthenticated
}

export const setCurrentUser = (state, user) => {
  state.currentUser = user
}

export const setLocale = (state, locale) => {
  state.locale = locale
}

export const setHasPaidLicense = (state, license) => {
  let licenseType   = license.license_type
  let licenseStatus = license.status

  switch (licenseStatus) {
    case 'expired': {
      state.currentUser.hasPaidLicense = false
      break
    }

    case 'active': {
      if (licenseType === 'free') {
        state.currentUser.hasPaidLicense = false
      }

      if (licenseType.startsWith('premium') || licenseType.startsWith('trial')) {
        state.currentUser.hasPaidLicense = true
      }

      state.currentUser.hasPremiumLicense = licenseType.startsWith('premium')
      break
    }

    default:
      state.currentUser.hasPaidLicense = false
  }
}
